import { NestedArrayHandler } from "../../handlers";
import { validators } from "./validators/validators";
export class InventoryPackagesV2 extends NestedArrayHandler {
    constructor(sdk) {
        super(sdk, "inventoryPackagesV2");
        this.validators = validators(sdk);
    }
    getKeyPath() {
        return "inventoryPackagesV2";
    }
}
//# sourceMappingURL=index.js.map